import { Component, EventEmitter, Input, Output, OnInit, ElementRef, AfterViewInit } from "@angular/core";

@Component({
  selector: 'upsell-sticky-bar',
  templateUrl: 'upsell-sticky-bar.html',
  styleUrls: ['upsell-sticky-bar.scss']
})
export class UpsellStickyBar implements OnInit, AfterViewInit {
  @Input() brand: string;
  @Input() name: string;
  @Input() image: string;
  @Input() quantity: any;
  @Input() productUnitType: string;
  @Input() total: number;
  @Input() addToCartText: string;

  @Input() showButton: boolean = false;
  @Input() buttonYesText: string = '';
  @Input() showbuttonYesText: boolean = true;
  @Input() buttonNoText: string = '';
  @Input() showbuttonNoText: boolean = true;
  @Input() description: string = '';
  @Input() showDescription: boolean = false;
  @Input() imageAlt: string = '';
  @Input() showImage: boolean = true;
  @Input() upsellCtaTextButtonsClass: string;

  @Output() itemAdded = new EventEmitter<boolean>();

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    // Component initialized
  }

  ngAfterViewInit() {
    // Wait for view to render, then apply padding
    setTimeout(() => {
      const height = this.elementRef.nativeElement.offsetHeight;
      const footer = document.querySelector('.upsell-footer') as HTMLElement;
      
      if (footer && height > 0) {
        footer.style.paddingBottom = `${height}px`;
      }
    }, 100);
  }

  addToCart() {
    this.itemAdded.emit(true);
  }
  
  nextPage(value: boolean | undefined) {
    this.itemAdded.emit(value);
  }
}